import { BaseTableColumn } from "src/app/shared/models/app-models/BaseTableColumn.model";
import { ExcoBoardDocumentRecord } from "../../shared/models/app-models/ExcoBoardDocument.model";
import { BlanketPurchaseRecord } from "../../shared/models/app-models/BlanketPurchaseDocument.model";
import { ReferenceRecord } from "../mypurchase-form/reference/dto/reference-record.model";
import { rfqGroupedData } from "../mypurchase-form/reference/reference.component";

export const ExcoBoardColumns: BaseTableColumn<ExcoBoardDocumentRecord>[] = [
  {
    columnDef: 'Id',
    header: 'Id',
    cell: (element: ExcoBoardDocumentRecord) => `${element.id}`,
  },
  {
    columnDef: 'FileReference',
    header: 'File Reference',
    cell: (element: ExcoBoardDocumentRecord) => `${element.FileReference}`,
  },
  {
    columnDef: 'Description',
    header: 'Description',
    cell: (element: ExcoBoardDocumentRecord) => `${element.Description}` as unknown as InnerHTML,
  },
  {
    columnDef: 'Type',
    header: 'Type',
    cell: (element: ExcoBoardDocumentRecord) => `${element.ProcessType}`,
  },
  {
    columnDef: 'Budget',
    header: 'Budget',
    cell: (element: ExcoBoardDocumentRecord) => `${element.Budget}`,
  },
  {
    columnDef: 'Approver',
    header: 'Approver',
    cell: (element: ExcoBoardDocumentRecord) => `${element.Approver}`,
  },
  {
    columnDef: 'PreapprovalDate',
    header: 'Preapproval Date',
    cell: (element: ExcoBoardDocumentRecord) => `${new Date(element.PreapprovalDate).toLocaleString()}`,
  },
  {
    columnDef: 'ValidFrom',
    header: 'Valid from',
    cell: (element: ExcoBoardDocumentRecord) => `${new Date(element.ValidFrom).toLocaleString()}`,
  },
  {
    columnDef: 'ValidTo',
    header: 'Valid to',
    cell: (element: ExcoBoardDocumentRecord) => `${new Date(element.ValidTo).toLocaleString()}`,
  },
  {
    columnDef: 'Amount',
    header: 'Amount(SGD)',
    cell: (element: ExcoBoardDocumentRecord) => `${element.Amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
  }
]

export const BlanketPurchaseColumns: BaseTableColumn<BlanketPurchaseRecord>[] = [
  {
    columnDef: 'Id',
    header: 'Id',
    cell: (element: BlanketPurchaseRecord) => `${element.DocumentNumber}`,
  },
  {
    columnDef: 'DocumentNumber',
    header: 'Document Number',
    cell: (element: BlanketPurchaseRecord) => `${element.DocumentNumber}`,
  },
  {
    columnDef: 'PurposeOfPurchase',
    header: 'Purpose of Purchase',
    cell: (element: BlanketPurchaseRecord) => `${element.PurposeOfPurchase}`,
  },
  {
    columnDef: 'BlanketType',
    header: 'Blanket Type',
    cell: (element: BlanketPurchaseRecord) => `${element.BlanketType}`,
  },
  {
    columnDef: 'BalanceAmount',
    header: 'Balance Amount',
    cell: (element: BlanketPurchaseRecord) => `${element.BalanceAmount}`,
  }
]
export const PROJECT_COMPLETION_MESSAGE = 'Please note that the project budget selected has a project with only 25% of the project schedule left or 6 months remaining before completion.'

export const ReferenceRecordColumns: BaseTableColumn<ReferenceRecord>[] = [
  {
    columnDef: 'childDocumentNo',
    header: 'Child document no.',
    cell: (element: ReferenceRecord) => `${element.childDocumentNumber}`,
  },
  {
    columnDef: 'parentItemNo',
    header: 'Parent item no. transferred',
    cell: (element: ReferenceRecord) => `${element.displayedParentId ?? '-'}`,
  },
  {
    columnDef: 'newItemNo',
    header: 'New item no.',
    cell: (element: ReferenceRecord) => `${element.displayedChildId ?? '-'}`,
  },
  {
    columnDef: 'vendorInvolved',
    header: 'Vendor Involved',
    cell: (element: ReferenceRecord) => `${element.vendorInvolved}`,
  },
  {
    columnDef: 'sourcingStatus',
    header: 'Sourcing Status',
    cell: (element: ReferenceRecord) => `${element.sourcingStatus}`,
  },
]

export const ReferenceRFQRecordColumns: BaseTableColumn<rfqGroupedData>[] = [
  {
    columnDef: 'rfqNumber',
    header: 'Request for Quotation no.',
    cell: (element: rfqGroupedData) => `${element.RFQNumber}`,
  },
  {
    columnDef: 'documentNumber',
    header: 'RFQ Summary Doc / Evaluation Report no.',
    cell: (element: rfqGroupedData) => `${element.groupedSummary}`,
  },
  {
    columnDef: 'poNumber',
    header: 'Purchase Order no.',
    cell: (element: rfqGroupedData) => `${element.podocs}`,
  }
]